import { sstPreviewUrl } from "./sstPreviewUrl";

export const URL_ACCESS = sstPreviewUrl(
  process.env.NEXT_PUBLIC_ACCESS_URL,
  "access",
);
